<template>
<div class="container">
  <QueryFrame
    :addText="handlePermission('medicineRecallAdd')?'新建召回计划':''"
    @handlePage='handlePage'
    @handlePageSize='handlePageSize'
    @addNew='addNew'
    :disablePage='disablePage'
    :count= 'count'
    :current="page"
  >
    <div slot="queryParams" class="form">
      <div class="queryContainer">
        <div class="queryItem">
            <goodsSearchItem v-model="query.nameMix"></goodsSearchItem>

          <!-- <label>商品名称:</label>
          <lk-input :maxlength="100" placeholder="请输入" class="item" v-model.trim="query.drugApprovedNames"></lk-input> -->
        </div>
        <div class="queryItem" v-if="roleType!==2">
          <label>门店名称:</label>
          <storeListSelect class="item" v-model="query.storeIds"></storeListSelect>
        </div>
        <div class="queryItem">
          <label>召回单号:</label>
          <lk-input :maxlength="100" placeholder="请输入" class="item" v-model.trim="query.recallPlanCode"></lk-input>
        </div>
        <!-- <div class="queryItem">
          <label>商品批号:</label>
          <lk-input :maxlength="100" placeholder="请输入" class="item" v-model.trim="query.licenseNumber"></lk-input>
        </div> -->
        <div class="queryItem">
          <label>召回时间:</label>
          <timeStampDatePicker type='daterange' class="item" placeholder=" 请选择" clearable v-model.trim='query.duration' />
        </div>
        <div class="queryItem">
          <lk-button class="mr" type="primary" @click="handleSearch">查询</lk-button>
          <lk-button @click="clear">重置</lk-button>
        </div>
      </div>
    </div>

    <div slot="table">
      <lk-table border :columns="columns" :data="tableData"></lk-table>
    </div>
  </QueryFrame>
</div>
</template>

<script>
import QueryFrame from '../../components/frame/QueryFrame.vue';
// import timeStampDatePicker from '../../components/timeStampDatePicker.vue';
import afterSale from '../../services/afterSale';
import utils from '../../libs/utils';
import mapState from '../../mixins/mapState'; // 鉴权
import queryMixins from '../../mixins/queryMixins';

export default {
  name: 'MedicineRecall',
  mixins: [mapState, queryMixins],
  data() {
    return {
      disablePage: false,
      params: {
        recallPlanCode: '', // 召回单号
        drugApprovedNames: '', // 商品名称
        licenseNumber: '', // 商品批号
        startTime: '', // 召回时间
        endTime: '',
        duration: [],
      },
      query: {
        storeIds: [],
        recallPlanCode: '', // 召回单号
        drugApprovedNames: '', // 商品名称
        licenseNumber: '', // 商品批号
        startTime: '', // 召回时间
        endTime: '',
        duration: [],
      },
      columns: [
        { title: '召回单号', key: 'saleRecallPlanRecallPlanCode', minWidth: 116 },
        { title: '商品名称', key: 'saleRecallPlanDrugApprovedNames', minWidth: 116 },
        { title: '商品编码', key: 'saleRecallPlanDrugSerialCode', minWidth: 116 },
        { title: '规格', key: 'saleRecallPlanSpecifications', minWidth: 116 },
        { title: '商品批号', key: 'saleRecallPlanLicenseNumber', minWidth: 116 },
        { title: '生产企业', key: 'saleRecallPlanManufacturer', minWidth: 116 },
        { title: '召回机构', key: 'saleRecallPlanRecallAgency', minWidth: 116 },
        {
          title: '召回时间',
          key: 'saleRecallPlanCreateTime',
          minWidth: 116,
          render: (h, params) => h('span', utils.exchangeTime(params.row.saleRecallPlanCreateTime)),
        },
        {
          title: '审批状态',
          key: 'saleRecallPlanRecallPlanStatus',
          minWidth: 116,
          render: (h, params) => {
            let statusStr = '';
            switch (params.row.saleRecallPlanRecallPlanStatus) {
              case 1:
                statusStr = '草稿';
                break;
              case 2:
                statusStr = '审批中';
                break;
              case 3:
                statusStr = '审批通过';
                break;
              case 4:
                statusStr = '驳回';
                break;
              case 5:
                statusStr = '审批通过';
                break;
              default:
                statusStr = '-';
            }
            return h('span', statusStr);
          },
        },
        {
          title: '召回状态',
          key: 'saleRecallPlanRecallPlanStatus',
          minWidth: 116,
          render: (h, params) => {
            if (params.row.saleRecallPlanRecallPlanStatus === 1
              || params.row.saleRecallPlanRecallPlanStatus === 2
              || params.row.saleRecallPlanRecallPlanStatus === 4) {
              return h('span', '-');
            }
            if (params.row.saleRecallPlanRecallPlanStatus === 5) {
              return h('span', '已完成');
            }
            return h('span', '待完成');
          },
        },
        {
          title: '操作',
          key: 'action',
          fixed: 'right',
          width: 130,
          render: (h, params) => h('div', {
            class: {
              textCenter: true,
            },
          }, [
            this.handlePermission('medicineRecallRecordCheck') && (params.row.saleRecallPlanRecallPlanStatus === 3 || params.row.saleRecallPlanRecallPlanStatus === 5) ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',

              },
              on: {
                click: () => {
                  // 查看召回结果详情,
                  this.$router.push({ name: 'medicineRecallRecordCheck', params: { id: params.row.saleRecallPlanId } });
                },
              },
            }, '查看') : null,

            this.handlePermission('medicineRecallCheck') && (params.row.saleRecallPlanRecallPlanStatus !== 5 && params.row.saleRecallPlanRecallPlanStatus !== 3) ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',

              },
              on: {
                click: () => {
                  // 查看召回计划详情,
                  this.$router.push({ name: 'medicineRecallCheck', params: { id: params.row.saleRecallPlanId } });
                },
              },
            }, '查看') : null,

            this.handlePermission('medicineRecallRecordEdit') && params.row.saleRecallPlanRecallPlanStatus === 3 ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.$router.push({ name: 'medicineRecallRecordEdit', params: { id: params.row.saleRecallPlanId } });
                },
              },
            }, '录入') : null,

            this.handlePermission('medicineRecallEdit') && (params.row.saleRecallPlanRecallPlanStatus !== 5 && params.row.saleRecallPlanRecallPlanStatus !== 3) ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
                disabled: params.row.saleRecallPlanRecallPlanStatus === 2,
              },
              on: {
                click: () => {
                  this.$router.push({ name: 'medicineRecallEdit', params: { id: params.row.saleRecallPlanId } });
                },
              },
            }, '编辑') : null,
          ]),
        },
      ],
      tableData: [],
    };
  },
  methods: {
    addNew() {
      this.$router.push({ name: 'medicineRecallAdd' });
    },
    getData() {
      this.params.page = this.page;
      this.params.size = this.size;
      if (this.params.duration[1]) {
        this.params.startTime = this.params.duration[0];
        this.params.endTime = this.params.duration[1];
      } else {
        this.params.endTime = '';
      }
      afterSale.recallPlanList(this.params).then((res) => {
        if (res.data.status === 200) {
          this.tableData = [];
          this.count = res.data.data.count;
          res.data.data.list.forEach((item) => {
            const result = {};
            utils.exchangeTable(item, result);
            this.tableData.push(result);
          });
          console.log(res.data);
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    // handleSearch() {
    //   this.params = Object.assign({}, this.query);
    //   this.handlePage(1, true);
    // },
    // handlePage(page, isSearch) {
    //   this.page = page;
    //   if (isSearch) {
    //     this.disablePage = true;
    //     this.$nextTick(() => {
    //       this.disablePage = false;
    //       this.size = 10;
    //       this.getData();
    //     });
    //   } else {
    //     this.getData();
    //   }
    // },
    // handlePageSize(size) {
    //   this.size = size;
    //   this.page = 1;
    //   this.getData();
    // },
    clear() {
      this.query = {
        storeIds: [],
        recallPlanCode: '', // 召回单号
        drugApprovedNames: '', // 商品名称
        licenseNumber: '', // 商品批号
        startTime: '', // 召回时间
        endTime: '',
        duration: [],
        nameMix: '',
      };
    },
  },
  mounted() {
    // this.getData();
    this.handleSearch(true);
    if (this.roleType !== 2) {
      this.columns.splice(0, 0, { title: '门店名称', key: 'saleRecallPlanStoreName', minWidth: 116 });
    }
  },
  components: {
    QueryFrame,
    // timeStampDatePicker,
  },
};
</script>

<style scoped>
</style>
